import {
    FiberPinRounded as FiberPinRoundedIcon,
    VisibilityOffOutlined as VisibilityOffOutlinedIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    Box, Button, CardContent, FormControl, FormControlLabel, InputAdornment, Switch, TextField, Tooltip,
    Typography
} from '@material-ui/core';
import api from '../../../services/api';
import React, { Component } from 'react';
import { ANAO, ASIM } from '../../../consts';
import { isInvalidSelect } from 'lib/configUtils';
import ComboPadrao from 'views/Components/ComboPadrao';
import { validateField, generateRandomPwd } from 'lib/functions';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class UsuarioPartnerForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usuariopartner: {
                id: '',
                nomeusuario: '',
                email: '',
                senha: '',
                codfornecedor: '',
                inativousuario: ANAO
            },
            confirmPwd: '',
            errors: {},
            fornecedores: [],
            isNewRecord: false,
            isView: false,
            showPwd: false,
            showConfirmPwd: false,
            schema: {
                nomeusuario: {
                    presence: { allowEmpty: false, message: 'Nome de usuário obrigatório!' },
                    length: { maximum: 100 },
                    type: 'string'
                },
                email: {
                    presence: { allowEmpty: false, message: 'E-mail inválido!' },
                    length: { maximum: 100 },
                    type: 'string'
                },
                senha: {
                    presence: { allowEmpty: false, message: 'Senha obrigatória!' },
                    length: { maximum: 8 },
                    type: 'string'
                },
                codfornecedor: {
                    presence: { allowEmpty: false, message: 'Fornecedor obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                }
            }
        }
    };

    async componentDidMount() {
        // carrega informações formulário
        const { id } = this.props.match.params;
        const { location } = this.props;
        const { usuariopartner } = this.state;
        const currentPath = location.pathname;

        if (id >= 0) {
            try {
                const response = await api.get(`/usuariopartner/${id}`);
                const dados = (response.data && response.data.data && response.data.data[0]) ? response.data.data[0] : {};

                // "let params" somente quando é preciso passar filtro específico de uma tabela
                let paramstransportadora = `?page=1&limit=500&tbfornecedor.transportadora=S`;

                const fornecedores = await api.get(`/fornecedor/active/true${paramstransportadora}`);
                this.setState({ fornecedores: fornecedores.data });

                console.log('DADOS RECEBIDOS DO BACKEND:', JSON.stringify(dados, null, 2));

                this.setState({
                    usuariopartner: {
                        ...dados,
                        inativousuario: dados.inativousuario || ANAO // garante default "N"
                    },
                    confirmPwd: dados.senha || '',
                    isNewRecord: false,
                    isView: (currentPath.includes('/view'))
                });
            } catch (error) {
                console.error('Erro ao carregar:', error);
            }
        }

        else if (id === 'novo') {
            this.setState({
                isNewRecord: true,
                usuariopartner: {
                    ...usuariopartner,
                    inativousuario: ANAO
                }
            });

            // "let params" somente quando é preciso passar filtro específico de uma tabela
            let paramstransportadora = `?page=1&limit=500&tbfornecedor.transportadora=S`;

            const fornecedores = await api.get(`/fornecedor/active/true${paramstransportadora}`);
            this.setState({ fornecedores: fornecedores.data });
        }
    };

    /* Evento on change componentes */
    onChange = (event) => {
        const { usuariopartner } = this.state;
        const { name, value, checked } = event.target;

        let newValue = value;

        // campos uppercase
        if (name === 'nomeusuario') {
            newValue = value.toUpperCase();
        }
        if (name === 'senha' || name === 'confirmPwd') {
            newValue = value.toUpperCase();
        }

        // switch ativo/inativo
        if (name === 'inativousuario') {
            newValue = checked ? ANAO : ASIM;
        }

        // confirmação de senha (não vai para o backend)
        if (name === 'confirmPwd') {
            this.setState({ confirmPwd: newValue });
            return;
        }

        this.setState({
            usuariopartner: {
                ...usuariopartner,
                [name]: newValue
            }
        });
    };

    /* Atualiza dados de usuário existente - post */
    handleUpdateUsuario = async () => {
        const { usuariopartner } = this.state;
        try {
            const response = await api.put(`/admusuariopartner/${usuariopartner.id}`, usuariopartner);
            if (response.status === 200) {
                this.props.history.push('/admpartner/usuariopartner');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }

        this.setState(prevState => ({
            usuariopartner: {
                ...prevState.usuariopartner
            }
        }));
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Click salvar */
    onClickSave = async () => {
        const { usuariopartner, isNewRecord, confirmPwd } = this.state;
        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
            return;
        }

        // valida confirmação de senha (somente comparação)
        if ((usuariopartner.senha || '') !== (confirmPwd || '')) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    confirmPwd: 'As senhas não coincidem!'
                }
            }));
            this.handleOpenAlert('As senhas não coincidem!');
            return;
        }

        // verifica valor inválido para codfornecedor
        if (isInvalidSelect(usuariopartner.codfornecedor)) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    codfornecedor: 'Selecione um fornecedor válido!'
                }
            }));
            this.handleOpenAlert('Selecione um fornecedor válido!');
            return;
        }

        try {
            // usa-se quando não há campos do tipo BLOB
            const payload = {
                codfornecedor: usuariopartner.codfornecedor || '',
                nomeusuario: usuariopartner.nomeusuario || '',
                email: usuariopartner.email || '',
                senha: usuariopartner.senha || '',
                inativousuario: usuariopartner.inativousuario || ''
            };

            console.log('Enviando para o backend (JSON):', payload);

            if (isNewRecord) {
                await api.post('/usuariopartner', payload);
            } else {
                await api.put(`/usuariopartner/${usuariopartner.id}`, payload);
            }

            if (this.props.loadUsuarios) this.props.loadUsuarios();
            this.props.history.push('/admpartner/usuariopartner');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);
            this.handleOpenAlert(error.response?.data?.error || 'Erro ao salvar!');
        }
    };

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/admpartner/usuariopartner');
    };

    /* Valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { usuariopartner, schema } = this.state;
        let errors = {};

        // valida campos do schema
        const requiredFields = [
            'nomeusuario',
            'email',
            'senha',
            'codfornecedor'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, usuariopartner[field], schema);
            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    /* Insere novo usuário */
    handleInsertUsuario = async () => {
        const { usuariopartner } = this.state;

        try {
            const response = await api.post(`/usuariopartner`, usuariopartner);
            if (response.status === 200) {
                this.props.history.push('/admpartner/usuariopartner');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Método alternar visibilidade senha */
    toggleShowPassword = () => {
        this.setState(prev => ({ showPwd: !prev.showPwd }));
    };

    /* Método alternar visibilidade confirmação senha */
    toggleShowConfirmPassword = () => {
        this.setState(prev => ({ showConfirmPwd: !prev.showConfirmPwd }));
    };

    /* Método gerar senha aleatória */
    handleGeneratePwd = () => {
        const pwd = generateRandomPwd(8);

        this.setState(prev => ({
            usuariopartner: {
                ...prev.usuariopartner,
                senha: pwd
            },
            confirmPwd: pwd
        }));
    };

    render() {
        const {
            isNewRecord,
            usuariopartner,
            fornecedores,
            errors,
            isView,
            openAlert,
            messageAlert,
            showPwd,
            confirmPwd,
            showConfirmPwd,

        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Usuário: {usuariopartner.nomeusuario}
                        </Typography>

                        <FormControlLabel
                            label={(usuariopartner.inativousuario === ASIM) ? 'Inativo' : 'Ativo'}
                            control={
                                <Switch
                                    checked={usuariopartner.inativousuario !== ASIM}
                                    name="inativousuario"
                                    onChange={this.onChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    {/* BOX PRIMEIRA LINHA */}
                    <Box>
                        <TextField
                            label="Nome do usuário"
                            name="nomeusuario"
                            value={usuariopartner.nomeusuario || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.nomeusuario || ''}
                            error={!!errors.nomeusuario}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{
                                width: '35%',
                                marginRight: '1rem'
                            }}
                        />

                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                width: '50%'
                            }}
                        >
                            <ComboPadrao
                                name={'codfornecedor'}
                                label={'Fornecedor'}
                                value={usuariopartner.codfornecedor}
                                onChange={this.onChange}
                                fieldId={'codfornecedor'}
                                listItems={fornecedores}
                                fieldDescription={'fantasia'}
                                helperText={errors.codfornecedor || ''}
                                error={!!errors.codfornecedor}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    {/* BOX SEGUNDA LINHA */}
                    <Box>
                        <TextField
                            label="E-mail"
                            name="email"
                            value={usuariopartner.email || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            type="email"
                            autoComplete="email"
                            inputMode="email"
                            helperText={errors.email || ''}
                            error={!!errors.email}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{ width: '86.5%' }}
                        />
                    </Box>

                    <br />

                    {/* BOX TERCEIRA LINHA */}
                    <Box
                        display="flex"
                        alignItems="flex-start"
                    >
                        <TextField
                            label="Senha"
                            name="senha"
                            value={usuariopartner.senha || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            type={showPwd ? 'text' : 'password'}
                            autoComplete={isNewRecord ? 'new-password' : 'current-password'}
                            helperText={errors.senha || ''}
                            error={!!errors.senha}
                            disabled={isView}
                            inputProps={{ maxLength: 8 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip
                                            title="Ver/ocultar senha"
                                            enterDelay={50}
                                        >
                                            <span>
                                                {showPwd ? (
                                                    <VisibilityOffOutlinedIcon
                                                        onClick={() => !isView && this.toggleShowPassword()}
                                                        onMouseEnter={(e) => (e.currentTarget.style.color = '#8e9091')}
                                                        onMouseLeave={(e) => (e.currentTarget.style.color = '#707172')}
                                                        style={{
                                                            fontSize: 22,
                                                            color: '#707172',
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                ) : (
                                                    <VisibilityOutlinedIcon
                                                        onClick={() => !isView && this.toggleShowPassword()}
                                                        onMouseEnter={(e) => (e.currentTarget.style.color = '#8e9091')}
                                                        onMouseLeave={(e) => (e.currentTarget.style.color = '#707172')}
                                                        style={{
                                                            fontSize: 22,
                                                            color: '#707172',
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                )}
                                            </span>
                                        </Tooltip>
                                    </InputAdornment>
                                )
                            }}
                            style={{
                                width: '40.4%',
                                marginRight: '1rem'
                            }}
                        />

                        <TextField
                            label="Confirmação senha"
                            name="confirmPwd"
                            value={confirmPwd || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            type={showConfirmPwd ? 'text' : 'password'}
                            autoComplete={isNewRecord ? 'new-password' : 'current-password'}
                            helperText={errors.confirmPwd || ''}
                            error={!!errors.confirmPwd}
                            disabled={isView}
                            inputProps={{ maxLength: 8 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip
                                            title="Ver/ocultar senha"
                                            enterDelay={50}
                                        >
                                            <span>
                                                {showConfirmPwd ? (
                                                    <VisibilityOffOutlinedIcon
                                                        onClick={() => !isView && this.toggleShowConfirmPassword()}
                                                        onMouseEnter={(e) => (e.currentTarget.style.color = '#8e9091')}
                                                        onMouseLeave={(e) => (e.currentTarget.style.color = '#707172')}
                                                        style={{
                                                            fontSize: 22,
                                                            color: '#707172',
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                ) : (
                                                    <VisibilityOutlinedIcon
                                                        onClick={() => !isView && this.toggleShowConfirmPassword()}
                                                        onMouseEnter={(e) => (e.currentTarget.style.color = '#8e9091')}
                                                        onMouseLeave={(e) => (e.currentTarget.style.color = '#707172')}
                                                        style={{
                                                            fontSize: 22,
                                                            color: '#707172',
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                )}
                                            </span>
                                        </Tooltip>
                                    </InputAdornment>
                                )
                            }}
                            style={{
                                width: '40.4%',
                                marginRight: '1rem'
                            }}
                        />

                        <Tooltip
                            title="Gerar senha"
                            enterDelay={50}
                        >
                            <FiberPinRoundedIcon
                                onClick={() => !isView && this.handleGeneratePwd()}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#356b87'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#2b576e'}
                                style={{
                                    fontSize: 32,
                                    color: '#2b576e',
                                    cursor: isView ? 'default' : 'pointer',
                                    marginTop: 10
                                }}
                            />
                        </Tooltip>
                    </Box>

                    <br />
                    <br />

                    <Box
                        display="flex"
                        style={{
                            flexWrap: 'wrap',
                            gap: 12,
                            marginTop: 10
                        }}
                    >
                        <Button
                            name="salvar"
                            color="primary"
                            variant="contained"
                            onClick={this.onClickSave}
                            disabled={isView}
                        >
                            Salvar
                        </Button>

                        <Button
                            name="cancelar"
                            variant="contained"
                            onClick={this.onClickCancel}
                            color="secondary"
                            style={{ marginLeft: 10 }}
                        >
                            Cancelar
                        </Button>
                    </Box>
                </CardContent >

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div >
        );
    }
}

export default UsuarioPartnerForm;